import { CheckCircleIcon, WarningCircleIcon } from "@phosphor-icons/react";

/*
  Every attempt the real hourly cron sweep evaluated as due for one
  schedule, read from public.schedule_delivery_log. Distinct from
  last_run_at/last_status on the schedule row itself, which only ever holds
  the single most recent attempt.

  This used to also show a separate "Manual test history" section for
  "Test schedule now" clicks — removed 2026-09-15 along with that button:
  with no way to generate one any more, a permanently-empty second section
  was just clutter.
*/
export default function ScheduleDeliveryHistory({ rows, testId = "schedule-history" }) {
  const list = rows || [];

  if (list.length === 0) {
    return (
      <div className="text-[10px] font-mono text-zinc-400 py-1.5" data-testid={`${testId}-empty`}>
        Nothing yet — the schedule hasn't fired on its own this week.
      </div>
    );
  }

  return (
    <div className="divide-y divide-border max-h-40 overflow-y-auto" data-testid={testId}>
      {list.map((r) => {
        const failed = /^error/i.test(r.status || "");
        return (
          <div key={r.id} className="flex items-start gap-2 py-2" data-testid={`${testId}-row-${r.id}`}>
            <span className="shrink-0 mt-0.5">
              {failed
                ? <WarningCircleIcon size={13} weight="fill" className="text-red-500" />
                : <CheckCircleIcon size={13} weight="fill" className="text-emerald-500" />}
            </span>
            <div className="min-w-0 flex-1">
              <div className="text-[10px] font-mono text-zinc-500">{new Date(r.ran_at).toLocaleString()}</div>
              <div className={`text-xs leading-snug ${failed ? "text-red-600" : "text-zinc-700"}`}>{r.status}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
